import { styled } from 'styled-components';

import { listingRichTextStyles } from './listingRichTextStyles';

export const ListingRichTextHolder = styled.div`
  overflow-wrap: anywhere;
  ${listingRichTextStyles};

  .ql-picker {
    &.ql-header {
      .ql-picker-label {
        &::before {
          content: '${getText('Body')}';
        }

        &[data-value='4']::before {
          content: '${getText('Headline')}';
        }
      }

      .ql-picker-item {
        &::before {
          font-size: 1em;
          content: '${getText('Body')}';
        }
        &[data-value='4']::before {
          content: '${getText('Headline')}';
        }
      }
    }
  }
`;
